import React from "react";
import { ReferenceLine } from "recharts";

import { getTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { theme } from "~/tools/twin-migration";

export interface TimestampCursorProps {
	timestamp: Time;
}

export const TimestampCursor: React.FC<TimestampCursorProps> = ({ timestamp }) => (
	<ReferenceLine stroke={theme("colors.graphite.300")} x={getTime(timestamp)} zIndex={500} />
);
